import React from 'react';
import PropTypes from 'prop-types';

function IconCart({ color = '#EF476F', size = 16, className }) {
  return (
    <svg id={'icon-cart'} width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.99976 2H4.52614L6.79988 12.4424C6.87862 12.8285 7.09029 13.1749 7.39803 13.421C7.70577 13.6672 8.09011 13.7977 8.48413 13.7898H14.9685C15.3625 13.7977 15.7469 13.6672 16.0546 13.421C16.3624 13.1749 16.574 12.8285 16.6528 12.4424L18.0002 5.36851H5.87354M8.31406 18C8.77916 18 9.15619 17.623 9.15619 17.1579C9.15619 16.6928 8.77916 16.3157 8.31406 16.3157C7.84897 16.3157 7.47194 16.6928 7.47194 17.1579C7.47194 17.623 7.84897 18 8.31406 18ZM15.0494 18C15.5145 18 15.8916 17.623 15.8916 17.1579C15.8916 16.6928 15.5145 16.3157 15.0494 16.3157C14.5843 16.3157 14.2073 16.6928 14.2073 17.1579C14.2073 17.623 14.5843 18 15.0494 18Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )

  // return (
  //   <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <g clipPath="url(#clip0_6463_682)">
  //       <path d="M6.66667 14.3333C7.03486 14.3333 7.33333 14.0349 7.33333 13.6667C7.33333 13.2985 7.03486 13 6.66667 13C6.29848 13 6 13.2985 6 13.6667C6 14.0349 6.29848 14.3333 6.66667 14.3333Z" fill="#EF476F" stroke="#EF476F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  //       <path d="M11.9987 14.3333C12.3669 14.3333 12.6654 14.0349 12.6654 13.6667C12.6654 13.2985 12.3669 13 11.9987 13C11.6305 13 11.332 13.2985 11.332 13.6667C11.332 14.0349 11.6305 14.3333 11.9987 14.3333Z" fill="#EF476F" stroke="#EF476F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  //       <path d="M1.66797 1.66699H3.66797L5.46797 9.93366C5.5303 10.2394 5.69787 10.5135 5.94149 10.7084C6.18512 10.9033 6.48937 11.0066 6.8013 11.0003H11.9346C12.2466 11.0066 12.5508 10.9033 12.7944 10.7084C13.0381 10.5135 13.2056 10.2394 13.268 9.93366L14.3346 4.33366H4.73464" stroke="#EF476F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_6463_682">
  //         <rect width="16" height="16" fill="white"/>
  //       </clipPath>
  //     </defs>
  //   </svg>
  // )
}

IconCart.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconCart;